import { useQuery } from '@tanstack/react-query';

import { getDescription } from '../api/descriptionApi';

export const useDescription = (name: string, lang: string = 'en') => {
  return useQuery({
    queryKey: ['description', name, lang],
    queryFn: () => getDescription(name, lang),
    enabled: !!name,
  });
};
